import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { CustomPropTypes } from '@beef/react';
import { Accordion, AccordionDropdown } from "../../../Accordion";
import DescriptionContent from "../DescriptionContent";
import DescriptionMenuitem from "../DescriptionMenuitem";
import styles from "../../styles.pcss";
var cx = classNames.bind(styles);

/**
 * This version of Descriptions is pretty useless standalone,
 * because it still handles mobile Accordion statefully
 *
 * Called with single possible childType - Description,
 * renders them in three different implementation:
 * - Accordion for mobile,
 * - leftSide links with content section for desktop
 */
var DescriptionsStateless = /*#__PURE__*/function (_React$Component) {
  _inherits(DescriptionsStateless, _React$Component);
  var _super = _createSuper(DescriptionsStateless);
  function DescriptionsStateless() {
    var _this;
    _classCallCheck(this, DescriptionsStateless);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderAs", function (Component, indexToProps, indexToVisibility) {
      return React.Children.map(_this.props.children, function (child, index) {
        if (indexToVisibility && !indexToVisibility(index)) return null;
        return /*#__PURE__*/React.createElement("h4", {
          className: cx('menu-item-wrapper'),
          "data-t-id": "components-DescriptionsStateless"
        }, /*#__PURE__*/React.cloneElement(child, _objectSpread({
          Component: Component
        }, indexToProps ? indexToProps(index) : null)));
      });
    });
    return _this;
  }
  _createClass(DescriptionsStateless, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        titleTag = _this$props.titleTag,
        additional = _this$props.additional,
        activeIndex = _this$props.activeIndex,
        onChangeIndex = _this$props.onChangeIndex,
        className = _this$props.className,
        domNodeRef = _this$props.domNodeRef,
        isMobile = _this$props.isMobile;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('wrapper', className),
        ref: domNodeRef
      }, isMobile ? /*#__PURE__*/React.createElement("div", {
        className: cx('mobile')
      }, /*#__PURE__*/React.createElement(Accordion, null, this.renderAs(AccordionDropdown)), additional) : /*#__PURE__*/React.createElement("div", {
        className: cx('desktop')
      }, /*#__PURE__*/React.createElement("div", {
        className: cx('navbar')
      }, this.renderAs(DescriptionMenuitem, function (itemIndex) {
        return {
          onClick: function onClick() {
            return onChangeIndex(itemIndex);
          },
          isActive: itemIndex === activeIndex
        };
      }), additional), /*#__PURE__*/React.createElement("div", {
        className: cx('content')
      }, this.renderAs(DescriptionContent, function () {
        return {
          TitleTag: titleTag
        };
      }, function (itemIndex) {
        return activeIndex === itemIndex;
      }))));
    }
  }]);
  return DescriptionsStateless;
}(React.Component);
export { DescriptionsStateless as default };
DescriptionsStateless.defaultProps = {
  titleTag: 'div'
};
DescriptionsStateless.propTypes = process.env.NODE_ENV !== "production" ? {
  domNodeRef: CustomPropTypes.ref,
  children: PropTypes.node.isRequired,
  // only Description can be used as children
  titleTag: PropTypes.string,
  // tagName used for heading in content section of children
  additional: PropTypes.element,
  // extra element rendered under accordion in mobile and under links leftside in desktop
  activeIndex: PropTypes.number,
  // active index for desktop implementation of description
  onChangeIndex: PropTypes.func,
  // callback function for when index changes
  className: PropTypes.string,
  // NC
  isMobile: PropTypes.bool // view depending on screen size
} : {};